module.exports = __webpack_public_path__ + "static/media/page101_04.79735396.jpg";